/* eslint-disable no-unused-vars */
// import React from 'react';
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
// import { ThemeProvider } from "@mui/material/styles";
import HomePage from "pages/HomePage/HomePage.js";
import Analytics from "pages/dashboard/analytics.js";
import AboutUs from "pages/analyticsTeam/aboutUs.js";
import ReportPage from "pages/Report/ReportPage.js";
import GridReport from "pages/gridReport/agridReport.js";
import Login from "pages/authentication/login.js";
// import LoginSuccessful from "pages/authentication/LandingPage.js";
import { PrivateRoutes } from "utils/PrivateRoutes.js";

import { useOpticStore } from "stores/optics.js";
import "assets/css/analytics.css";
import Looker from "pages/LookerEmbed";
import LookerTester from "pages/LookerTester";
import { SessionExpired } from "components/SessionExpired";

export default function Optics() {
  const isLoggedin = useOpticStore((state) => state.isLoggedin); //check if the user is logged in
  // const isLoggedin = true;
  return (
    <div className="Optics">
      <Router>
        <SessionExpired />
        <Routes>
          <Route
            element={
              isLoggedin ? <PrivateRoutes /> : <Navigate to={"/login"} />
            }
          >
            <Route element={<HomePage />} exact path="/" />
            <Route element={<Analytics />} exact path="/Analytics" />
            <Route element={<AboutUs />} exact path="/OurTeam" />
            <Route element={<ReportPage />} exact path="/Report" />
            <Route element={<GridReport />} exact path="/GridReport" />
          </Route>
          <Route
            element={!isLoggedin ? <Login /> : <Navigate to={"/"} />}
            exact
            path="/login"
          />
          <Route element={<Looker />} path="/looker/:category/:sub" />
          <Route element={<LookerTester />} path="/looker_tester" />
        </Routes>
      </Router>
    </div>
  );
}
